import nl from './nl';

export default {
    nl
};



// WEBPACK FOOTER //
// ./src/app/i18n/index.js